 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~home~services":"about~home~services","about":"about","home":"home","add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2":"add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2","add-album~edit-album":"add-album~edit-album","add-album":"add-album","edit-album":"edit-album","add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services":"add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services","add-banner":"add-banner","add-news":"add-news","add-testimonial":"add-testimonial","edit-news":"edit-news","edit-testimonial":"edit-testimonial","add-company":"add-company","add-member":"add-member","banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials":"banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials","services":"services","edit-company":"edit-company","edit-member":"edit-member","feedback-reply":"feedback-reply","banners":"banners","cms-news":"cms-news","companies":"companies","feedbacks":"feedbacks","projects-albums":"projects-albums","subscribers":"subscribers","team":"team","testimonials":"testimonials","change-password":"change-password","company-detail":"company-detail","contact-us":"contact-us","feedback-detail":"feedback-detail","forgot-password":"forgot-password","login":"login","news":"news","newsDetail":"newsDetail","not-found":"not-found","projects":"projects","reset-password":"reset-password"}[chunkId]||chunkId) + "." + {"about~home~services":"32f4c831","about":"923a394c","home":"f1beab36","add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2":"0624811d","add-album~edit-album":"54d73d2e","add-album":"83854469","edit-album":"98fb8aac","add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services":"3c81d5f4","add-banner":"c508a80a","add-news":"2b621f17","add-testimonial":"3ece42ec","edit-news":"8b8aa962","edit-testimonial":"073709af","add-company":"eb87ef25","add-member":"e6edebbe","banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials":"51b47243","services":"69d229de","edit-company":"9f84cb70","edit-member":"57bab11f","feedback-reply":"f60f173f","banners":"c575d7c6","cms-news":"ae040b79","companies":"91486c45","feedbacks":"68bd81cc","projects-albums":"4735db21","subscribers":"c68b055a","team":"9f64c00e","testimonials":"993d6352","change-password":"ebbeb4e1","company-detail":"76dbc319","contact-us":"4782fb91","feedback-detail":"14e17bb6","forgot-password":"3e0cf356","login":"92889932","news":"b711f6dd","newsDetail":"d9ffa98d","not-found":"065ce847","projects":"522291a0","reset-password":"32e9371f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~home~services":1,"about":1,"home":1,"add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2":1,"add-album~edit-album":1,"add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services":1,"add-banner":1,"add-news":1,"add-testimonial":1,"edit-news":1,"edit-testimonial":1,"add-company":1,"add-member":1,"services":1,"edit-company":1,"edit-member":1,"feedback-reply":1,"banners":1,"cms-news":1,"companies":1,"feedbacks":1,"projects-albums":1,"subscribers":1,"team":1,"testimonials":1,"change-password":1,"company-detail":1,"contact-us":1,"feedback-detail":1,"forgot-password":1,"login":1,"news":1,"newsDetail":1,"not-found":1,"projects":1,"reset-password":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~home~services":"about~home~services","about":"about","home":"home","add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2":"add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2","add-album~edit-album":"add-album~edit-album","add-album":"add-album","edit-album":"edit-album","add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services":"add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services","add-banner":"add-banner","add-news":"add-news","add-testimonial":"add-testimonial","edit-news":"edit-news","edit-testimonial":"edit-testimonial","add-company":"add-company","add-member":"add-member","banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials":"banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials","services":"services","edit-company":"edit-company","edit-member":"edit-member","feedback-reply":"feedback-reply","banners":"banners","cms-news":"cms-news","companies":"companies","feedbacks":"feedbacks","projects-albums":"projects-albums","subscribers":"subscribers","team":"team","testimonials":"testimonials","change-password":"change-password","company-detail":"company-detail","contact-us":"contact-us","feedback-detail":"feedback-detail","forgot-password":"forgot-password","login":"login","news":"news","newsDetail":"newsDetail","not-found":"not-found","projects":"projects","reset-password":"reset-password"}[chunkId]||chunkId) + "." + {"about~home~services":"24f7d054","about":"55a3e5c2","home":"1ceae2e9","add-album~add-banner~add-company~add-member~add-news~add-testimonial~edit-album~edit-company~edit-me~f17889d2":"c253b34b","add-album~edit-album":"00ecd470","add-album":"31d6cfe0","edit-album":"31d6cfe0","add-banner~add-news~add-testimonial~edit-news~edit-testimonial~feedback-reply~services":"8900952c","add-banner":"132a9307","add-news":"651fde66","add-testimonial":"132a9307","edit-news":"8c65c44d","edit-testimonial":"132a9307","add-company":"132a9307","add-member":"132a9307","banners~cms-news~companies~feedbacks~projects-albums~services~subscribers~team~testimonials":"31d6cfe0","services":"9d25eb99","edit-company":"132a9307","edit-member":"132a9307","feedback-reply":"c253b34b","banners":"c253b34b","cms-news":"c253b34b","companies":"c253b34b","feedbacks":"89ce71c0","projects-albums":"c253b34b","subscribers":"c253b34b","team":"c253b34b","testimonials":"c253b34b","change-password":"c253b34b","company-detail":"4cb09c11","contact-us":"73ba6e35","feedback-detail":"c253b34b","forgot-password":"ee06a0a1","login":"ee06a0a1","news":"0b1e4182","newsDetail":"8b7746b4","not-found":"0ea540c4","projects":"081a3082","reset-password":"ee06a0a1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
